import { render, staticRenderFns } from "./StudentDetailsModal.vue?vue&type=template&id=55e81fc6&scoped=true&"
import script from "./StudentDetailsModal.vue?vue&type=script&lang=js&"
export * from "./StudentDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./StudentDetailsModal.vue?vue&type=style&index=0&id=55e81fc6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e81fc6",
  null
  
)

export default component.exports